// extracted by mini-css-extract-plugin
module.exports = {"paper":"LauncherUpgrade_paper__1k4n-","divider":"LauncherUpgrade_divider__y1lCR","header":"LauncherUpgrade_header__aABU_"};